"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.array.find");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _popupTypes = require("@/utils/popupTypes.js");
var _index = require("@/utils/index.js");
var _memberManagement = require("@/api/member/memberManagement");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderHomePopup',
  data: function data() {
    return {
      loading: false,
      activeTab: "0",
      searchForm: {
        type: '',
        page: 1,
        limit: 10,
        total: 0,
        param: '',
        // 弹窗类型 2首页 (点餐首页)
        popType: _popupTypes.PopupTypes.POP_TYPE.HOME,
        status: ''
      },
      imagePrefix: '',
      tableData: [],
      // 页面路径到页面名称的映射
      pageMap: new Map(),
      // CDP分组类型映射
      cdpGrpTypeMap: {
        0: '不匹配',
        1: 'CDP分组',
        2: '消费行为'
      },
      // CDP分组类型标签样式映射
      cdpGrpTypeTagMap: {
        0: 'info',
        1: 'success',
        2: 'warning'
      }
    };
  },
  methods: {
    // 获取图片资源前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              console.log('获取图片前缀响应：', response);
              if (response.code === 200) {
                this.imagePrefix = response.data;
                console.log('获取图片前缀成功：', this.imagePrefix);
              } else {
                console.error('获取图片前缀失败：', response.message);
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀错误：', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取页面列表并构建映射
    getPageList: function getPageList() {
      var _this = this;
      return (0, _popupConfig.queryPageList)().then(function (response) {
        if (response.code === 200 && response.data) {
          // 构建页面路径到页面名称的映射（包含appid信息）
          response.data.forEach(function (page) {
            _this.pageMap.set(page.id, {
              name: page.pageName,
              appid: page.appid
            });
          });
          // console.log('页面映射构建成功:', this.pageMap);
        } else {
          console.error('获取页面列表失败:', response.message);
        }
        return response;
      }).catch(function (error) {
        console.error('获取页面列表错误:', error);
        return null;
      });
    },
    // 搜索
    handleSearch: function handleSearch() {
      var _this2 = this;
      this.searchForm.page = 1;
      // 确保页面映射已构建
      if (this.pageMap.size === 0) {
        this.getPageList().then(function () {
          _this2.fetchList();
        });
      } else {
        this.fetchList();
      }
    },
    // 标签页切换
    handleTabChange: function handleTabChange(value) {
      var _this3 = this;
      this.searchForm.recommendType = value;
      this.searchForm.page = 1;
      // 确保页面映射已构建
      if (this.pageMap.size === 0) {
        this.getPageList().then(function () {
          _this3.fetchList();
        });
      } else {
        this.fetchList();
      }
    },
    // 获取数据
    fetchList: function fetchList() {
      var _this4 = this;
      this.loading = true;
      // 调用API获取数据
      (0, _popupConfig.getPopupConfigPage)(this.searchForm).then(function (response) {
        // 根据实际返回的数据结构调整
        if (response.records) {
          _this4.tableData = response.records.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              // 映射字段名以匹配组件使用
              showStartTime: item.showStartTime || item.startTime || '',
              showEndTime: item.showEndTime || item.endTime || '',
              isEnable: item.isEnable !== undefined ? item.isEnable : false,
              isShow: item.isShow !== undefined ? item.isShow : true,
              recommendPriority: item.recommendPriority !== undefined ? item.recommendPriority : 0,
              showImage: item.showImage || item.image || '',
              recommendType: item.recommendType || item.type || 1,
              // CDP分组相关字段
              cdpGrpType: item.cdpGrpType !== undefined ? item.cdpGrpType : 0,
              cdpGrpId: item.cdpGrpId || null
            });
          });
          _this4.searchForm.total = response.total || 0;
        } else {
          _this4.tableData = [];
          _this4.searchForm.total = 0;
        }
        _this4.loading = false;
      }).catch(function (error) {
        console.error('获取弹窗配置列表失败:', error);
        _this4.$message.error('获取弹窗配置列表失败');
        _this4.tableData = [];
        _this4.searchForm.total = 0;
        _this4.loading = false;
      });
    },
    // 保存或修改弹窗配置
    saveOrUpdatePopup: function saveOrUpdatePopup(popupData) {
      var _this5 = this;
      return (0, _popupConfig.saveOrUpdatePopupConfig)(popupData).then(function (response) {
        _this5.$message.success('保存成功');
        _this5.fetchList(); // 保存成功后刷新列表
        return response;
      }).catch(function (error) {
        console.error('保存弹窗配置失败:', error);
        _this5.$message.error('保存弹窗配置失败');
        throw error;
      });
    },
    // 删除弹窗配置
    removePopupConfig: function removePopupConfig(id) {
      var _this6 = this;
      return (0, _popupConfig.deletePopupConfig)(id).then(function (response) {
        _this6.$message.success('删除成功');
        _this6.fetchList(); // 删除成功后刷新列表
        return response;
      }).catch(function (error) {
        console.error('删除弹窗配置失败:', error);
        _this6.$message.error('删除弹窗配置失败');
        throw error;
      });
    },
    // 更新弹窗配置状态
    updatePopupStatus: function updatePopupStatus(id, isEnable) {
      var _this7 = this;
      return (0, _popupConfig.updatePopupConfigStatus)(id).then(function (response) {
        _this7.$message.success("\u5DF2".concat(isEnable ? '启用' : '禁用', "\u5F39\u7A97\u914D\u7F6E"));
        return response;
      }).catch(function (error) {
        console.error('更新弹窗配置状态失败:', error);
        _this7.$message.error('更新弹窗配置状态失败');
        // 恢复开关状态
        var popup = _this7.tableData.find(function (item) {
          return item.id === id;
        });
        if (popup) {
          popup.isEnable = !isEnable;
        }
        throw error;
      });
    },
    // 更新弹窗展示状态
    updatePopupShowStatus: function updatePopupShowStatus(id, isShow) {
      var _this8 = this;
      return (0, _popupConfig.updatePopupShowStatus)(id).then(function (response) {
        _this8.$message.success("\u5DF2".concat(isShow ? '展示' : '隐藏', "\u5F39\u7A97\u914D\u7F6E"));
        return response;
      }).catch(function (error) {
        console.error('更新弹窗展示状态失败:', error);
        _this8.$message.error('更新弹窗展示状态失败');
        // 恢复开关状态
        var popup = _this8.tableData.find(function (item) {
          return item.id === id;
        });
        if (popup) {
          popup.isShow = !isShow;
        }
        throw error;
      });
    },
    // 状态切换
    handleStatusChange: function handleStatusChange(row) {
      this.updatePopupStatus(row.id, row.isEnable);
    },
    // 展示状态切换
    handleShowChange: function handleShowChange(row) {
      this.updatePopupShowStatus(row.id, row.isShow);
    },
    // 添加弹框 - 触发父组件事件
    primary: function primary() {
      this.$emit('add-popup', 'orderHome');
    },
    // 导出数据
    handleExport: function handleExport() {
      this.$message.success('开始导出弹窗数据');
      // 这里可以调用API下载数据
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      // 只传递ID给父组件，由表单组件自行根据ID请求详情
      this.$emit('edit-popup', 'orderHome', row.id);
    },
    // 复制
    handleCopy: function handleCopy(row) {
      // 触发父组件事件，传递数据给父组件
      this.$emit('add-popup', 'orderHome', row.id);
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this9 = this;
      this.$confirm('确定要移除此弹窗配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this9.removePopupConfig(row.id);
      }).catch(function () {
        _this9.$message.info('已取消移除');
      });
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(size) {
      var _this0 = this;
      this.searchForm.limit = size;
      this.searchForm.page = 1;
      // 确保页面映射已构建
      if (this.pageMap.size === 0) {
        this.getPageList().then(function () {
          _this0.fetchList();
        });
      } else {
        this.fetchList();
      }
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(page) {
      var _this1 = this;
      this.searchForm.page = page;
      // 确保页面映射已构建
      if (this.pageMap.size === 0) {
        this.getPageList().then(function () {
          _this1.fetchList();
        });
      } else {
        this.fetchList();
      }
    },
    // 获取类型标签样式
    getTypeTagType: function getTypeTagType(recommendType) {
      return _popupTypes.RecommendTypeTagMap[recommendType] || '';
    },
    // 获取类型文本
    getTypeText: function getTypeText(recommendType) {
      return _popupTypes.RecommendTypeTextMap[recommendType] || '未知类型';
    },
    // 获取推荐内容名称根据类型 （根据接口返回的类型去比较）
    getRecommendContent: function getRecommendContent(row) {
      // 选页面类型(3/4/8)及外部小程序-社区：recommendContentId 为页面ID，尝试获取对应的页面名称
      if (row.recommendType == 3 || row.recommendType == 4 || row.recommendType == 6 || row.recommendType == 8) {
        // 检查是否有对应的页面名称
        var pageInfo = this.pageMap.get(Number(row.recommendContentId));
        if (pageInfo) {
          return this.appendParam(pageInfo.name, row);
        }
      }

      // 外部小程序-其他：recommendContent 为appid，recommendContentId 为跳转地址
      if (row.recommendContentId != null && row.recommendContent != null && row.recommendContentId != '') {
        return this.appendParam(row.recommendContent + "/" + row.recommendContentId, row);
      } else if (row.recommendContentId != null && row.recommendContentId != '') {
        return this.appendParam(row.recommendContentId, row);
      }
      return this.appendParam(row.recommendContent, row);
    },
    // 拼接参数
    appendParam: function appendParam(content, row) {
      if (content && row.recommendContentParam != null && row.recommendContentParam !== '') {
        return content + '?' + row.recommendContentParam;
      }
      return content;
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 获取分组类型标签样式
    getCdpGrpTypeTagType: function getCdpGrpTypeTagType(cdpGrpType) {
      return this.cdpGrpTypeTagMap[cdpGrpType] || 'info';
    },
    // 获取分组类型文本
    getCdpGrpTypeText: function getCdpGrpTypeText(cdpGrpType) {
      return this.cdpGrpTypeMap[cdpGrpType] || '不匹配';
    }
  },
  mounted: function mounted() {
    var _this10 = this;
    // 先获取页面列表，再获取数据
    this.getPageList().then(function () {
      _this10.fetchList();
    });
    this.getImagePrefix();
  }
};